import _find from 'lodash/find';

/**
 * La caisse cache-t-elle les produits indisponibles (Réglages › Prise de
 * commande sur l'app) ?
 * @param {Object[]} variables table variable
 * @returns {Boolean}
 */
export function isIpadViewAvailable(variables) {
	const variable = _find(variables || [], v => v.key_ === 'hide_disabled_product');
	return !!variable && variable.value == '1';
}

/**
 * Reproduit la grille de prise de commande de l'app : les items indisponibles
 * sont retirés et ceux qui suivent remontent d'une case chacun. Les espaces
 * restent des espaces, ils peuvent seulement changer de place. Les poids ne
 * sont pas modifiés : ce n'est qu'une lecture de la grille.
 * Si la caisse ne cache pas les indisponibles, ils restent à leur place.
 * @param {Object[]} items items de la grille, espaces compris, triés par poids
 * @param {Boolean} [hideDisabled] la caisse cache les indisponibles
 * @returns {Object[]}
 */
export function compactForIpadView(items, hideDisabled = true) {
	const compacted = hideDisabled
		? items.filter(item => item.isSpace || item.active == null || !!Number(item.active))
		: items.slice();
	// Sur l'app, les cases vides de fin de grille ne se voient pas.
	while (compacted.length && compacted[compacted.length - 1].isSpace) {
		compacted.pop();
	}
	return compacted;
}

/**
 * Pas de caisse derrière la base courante : siège (master sans établissement
 * sélectionné) ou zone. La « Vue caisse » n'y a pas de sens.
 * @param {Object} session
 * @param {Boolean} session.isMaster compte siège (state.user.master)
 * @param {String} session.accessMode state.access.mode
 * @param {String} [session.masterMonoChild] établissement sélectionné par le siège
 * @param {String} [session.idZone] zone de travail
 * @returns {Boolean}
 */
export function hasNoRegister({ isMaster, accessMode, masterMonoChild, idZone }) {
	if (accessMode === 'zone' || !!idZone) return true;
	return !!isMaster && !masterMonoChild;
}
